import { request } from './request';

//
export const getLoginNonce = async (params = {}, options = {}) => {
    const data = await request.post('/v1/auth/nonce', params, options);

    return data;
};

export const login = async (params = {}, options = {}) => {
    const data = await request.post('/v1/auth/space5/login', params, options);

    return data;
};

// 获取验证码
export const getCaptcha = async (params = {}, options = {}) => {
    const data = await request.post('/v1/auth/space5/captcha', params, options);

    return data;
};

// 获取短信验证码
export const getSms = async (params = {}, options = {}) => {
    const data = await request.post('/v1/auth/space5/sms', params, options);

    return data;
};

//  注册
export const register = async (params = {}, options = {}) => {
    const data = await request.post('/v1/auth/space5/register', params, options);

    return data;
};
